import { z } from 'zod';

import { zToolCategory } from '#models/ChatMessageModelSpec.js';

export const DebugToolDefinitionSchema = z
  .object({
    name: z.string(),
    description: z.string().nullish(),
    category: zToolCategory.nullish(),
    actionType: z.string().nullish(),
    inputSchemaDump: z.string().nullish(),
    outputSchemaDump: z.string().nullish(),
    metadata: z.record(z.string(), z.any()).optional(),
    available: z.boolean(),
  })
  .passthrough()
  .describe('DebugToolDefinitionSchema');

export type DebugToolDefinitionSchema = typeof DebugToolDefinitionSchema;
export type DebugToolDefinition = z.output<DebugToolDefinitionSchema>;
export type DebugToolDefinitionInput = z.input<DebugToolDefinitionSchema>;
